export default __webpack_public_path__ + "static/media/Visa.7a1929eb.svg";